import type { SetOutPointForSourceAction } from '../timelineActions';
import type { TimelineInternalOps } from '../../timelineInternalOps';


export function setOutPointForSource(timelineInternalHelper: TimelineInternalOps, action: SetOutPointForSourceAction) {
  action.undo = timelineInternalHelper.setOutPointOfTrackBoxGroup(action.sourceId, action.newOutPointInSeconds, action.sourcesDelta);
}

